import React from "react";
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setStep, setInfo, setLatest, setCurrent } from "../../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextInfoButton from "../../partials/NextInfoButton";

import AccountLayout from '../../../containers/AccountLayout';

/*
    PhoneVerification view that displays the Phone Verification page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class LivingSituation extends React.Component {

  constructor(){
    super();

    this.livingchecked = false;
    this.howlongchecked = false;

    this.handleLivingChange = this.handleLivingChange.bind(this);
    this.handleHowLongChange = this.handleHowLongChange.bind(this);
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Living Situation");
    this.props.lateststep < 4 && this.props.setLatest(4);
    this.props.setCurrent(4);
    this.props.setStep(1);
    this.props.setInfo(2);

    if (this.props.rentorown.length > 0){
      let querydataanswer = "[data-answer='"+this.props.rentorown+"']";
      document.querySelectorAll(querydataanswer)[0].classList.add('picked');
      this.livingchecked = true;
      document.getElementById("howlongbuttons").classList.remove("hidden");
      if (this.props.livinghowlong.length > 0){
        querydataanswer = "[data-answer='"+this.props.livinghowlong+"']";
        document.querySelectorAll(querydataanswer)[0].classList.add('picked');
        this.howlongchecked = true;
      }
    }
  }

  handleLivingChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.livingbutton'), function(el) {
      el.classList.remove("picked");
    });

    let rentown = e.target.dataset.answer;
    if (e.target.classList.contains('livingbutton')){
      e.target.classList.add("picked");
    } else {
      e.target.parentNode.classList.add("picked");
      rentown = e.target.parentNode.dataset.answer;
    }
    this.props.updateForm("rentorown", rentown);

    const howlong = document.getElementById("howlongbuttons");
    howlong.classList.remove("hidden");
    if (window.pageYOffset < 300)
      scroll.scrollTo(300, {duration: 1000});

    this.livingchecked = true;
  }

  handleHowLongChange(e) {

    [].forEach.call( document.querySelectorAll('.howlongbutton'), function(el) {
      el.classList.remove("picked");
    });

    let howlong = "";
    if (e.target.classList.contains('howlongbutton')){
      e.target.classList.add("picked");
      howlong = e.target.dataset.answer;
    } else {
      if (e.target.parentNode.classList.contains('howlongbutton')){
        e.target.parentNode.classList.add("picked");
        howlong = e.target.parentNode.dataset.answer;
      } else if (e.target.parentNode.parentNode.classList.contains('howlongbutton')){
        e.target.parentNode.parentNode.classList.add("picked");
        howlong = e.target.parentNode.parentNode.dataset.answer;
      }
    }

    this.props.updateForm("livinghowlong", howlong);
    this.howlongchecked = true;
  }

  render() {
    const nextInfo = 2;
    const nextLink = "/employmentinfo";
    const btnText = "Continue";
    const btnClasses = "btn next-step";

      return (
        <AccountLayout>
          <div className="container" id="stepper-step-3">
            <div className="text-center topcopy">
                <h1>Do you rent or own your home?</h1>
            </div>
            <form className="flowform">
              <hr />
              <div id="livingcheck" className="tilebutton-group text-center">
                  <div className="button-group">
                    <a className="btn tilebutton livingbutton" id="rent" data-answer="Rent" onClick={this.handleLivingChange} tabIndex="1">
                      <span>Rent</span>
                      <img className="style-svg" src="/images/svg/rent.svg" alt="rent icon" style={{marginTop:'13px',marginBottom:'12px'}}/>
                    </a>
                    <a className="btn tilebutton livingbutton" id="own" data-answer="Own" onClick={this.handleLivingChange} tabIndex="2">
                      <span>Own</span>
                      <img className="style-svg" src="/images/svg/own.svg" alt="own icon"/>
                    </a>
                  </div>
                  <div className="cf"></div>
              </div>

              <div id="howlongbuttons" className="hidden">
                  <p className="buttontitle">I&#39;ve been living at {this.props.street} for</p>
                  <div className="button-group">
                      <a className="btn mutedstrip-radio howlongbutton" data-answer="less than 1 year" id="less1yr" onClick={this.handleHowLongChange} tabIndex="3">
                        <div></div><span>less than 1 year</span>
                      </a>
                      <a className="btn mutedstrip-radio howlongbutton" data-answer="1 - 5 years" id="1-5yrs" onClick={this.handleHowLongChange} tabIndex="5">
                        <div></div><span>1 - 5 years</span>
                      </a>
                      <a className="btn mutedstrip-radio howlongbutton" data-answer="more than 5 years" id="more5yrs" onClick={this.handleHowLongChange} tabIndex="6">
                        <div></div><span>more than 5 years</span>
                      </a>
                  </div>
              </div>

              <NextInfoButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.howlongchecked} hideNext={!this.livingchecked} infostep={nextInfo} id="addresschecked" tabIndex="7"/>

            </form>
          </div>
        </AccountLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    street: state.FormReducer.street,
    rentorown: state.FormReducer.rentorown,
    livinghowlong: state.FormReducer.livinghowlong,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step)),
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LivingSituation)



// WEBPACK FOOTER //
// ./src/components/views/LivingSituation/index.js